export default {
    DEFAULT: 'default',
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning'
}
